module.exports = __webpack_public_path__ + "15d8d936.svg";